import cx from 'classnames';
import { GatsbyImageProps } from 'gatsby-plugin-image';
import React from 'react';

import { Image } from '../../index';
import * as styles from './FeaturedPanel.module.css';

const FeaturedPanel = ({
	children,
	image,
	alt,
	size = 'lg',
	noMaxWidth = false,
	svg,
	as: Component = 'div',
	className = '',
	isCampaign,
}: {
	children: React.ReactNode;
	image?: GatsbyImageProps;
	alt?: string;
	size?: 'sm' | 'lg';
	wide?: boolean;
	svg?: React.ReactNode;
	as?: React.ElementType;
	className?: string;
	noMaxWidth?: boolean;
	isCampaign?: boolean;
}) => {
	return (
		<>
			{size === 'sm' ? (
				<Component
					className={cx(
						styles.panel,
						styles['smPanel'],
						{
							[styles.noMaxWidth]: noMaxWidth,
						},
						className
					)}>
					<div className={styles.image}>
						<Image image={image} alt={alt} />
					</div>
					<div className={styles.box}>
						{svg && <div className={styles.svg}>{svg}</div>}
						<div className={styles.content}>{children}</div>
					</div>
				</Component>
			) : isCampaign ? (
				<Component
					className={cx(
						styles.panel,
						styles['isCampaign'],
						{
							[styles.noMaxWidth]: noMaxWidth,
						},
						className
					)}>
					<div className={styles.box}>
						{svg && <div className={styles.svg}>{svg}</div>}
						<div className={styles.isCampaignContent}>
							<div className={styles.isCampaignDesc}>{children}</div>
						</div>
					</div>
				</Component>
			) : (
				<Component
					className={cx(
						styles.panel,
						styles['lgPanel'],
						{
							[styles.noMaxWidth]: noMaxWidth,
						},
						className
					)}>
					<div className={styles['imageLarge']}>
						<Image image={image} alt={alt} />
					</div>
					<div className={styles.box}>
						{svg && <div className={styles.svg}>{svg}</div>}
						<div className={styles.content}>{children}</div>
					</div>
				</Component>
			)}
		</>
	);
};

export default FeaturedPanel;
